import { WS_CONNECTION_FAILED } from '../actionTypes/networkActionTypes';

export const wsConnectionFailed = (failed: boolean) => ({
    type: WS_CONNECTION_FAILED,
    payload: failed
});
